// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"88c7ebdd","168":"a181fedc"}[chunkId] + ".chunk.js";
};